<template>
  <div class="section-panel section-panel-tips">
    <div class="section-panel-header">
      <div class="section-panel-header-title">
        <div class="icon branded-icon">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M12,6 C15.3137085,6 18,8.6862915 18,12 C18,14.1777646 16.828786,16.1410513 15.0004585,17.1971297 L15,21 C15,22.6568542 13.6568542,24 12,24 C10.3431458,24 9,22.6568542 9,20.9998956 L9.00039701,17.1976247 L8.79232805,17.0717963 C7.08321232,15.9903189 6,14.0943518 6,12 C6,8.6862915 8.6862915,6 12,6 Z M12,8 C9.790861,8 8,9.790861 8,12 C8,13.6056446 8.95446234,15.0360331 10.4007399,15.6677643 C10.7650518,15.8268951 11.0005026,16.1867125 11.0004611,16.5842621 L11,21 C11,21.5522847 11.4477153,22 12,22 C12.5522847,22 13,21.5522847 13,20.9998794 L13.0005324,16.5836031 C13.0005803,16.1862143 13.2359239,15.8265633 13.6000537,15.6674176 C15.0459102,15.0354948 16,13.6053328 16,12 C16,9.790861 14.209139,8 12,8 Z M1,11 L3,11 C3.55228475,11 4,11.4477153 4,12 C4,12.5128358 3.61395981,12.9355072 3.11662113,12.9932723 L3,13 L1,13 C0.44771525,13 0,12.5522847 0,12 C0,11.4871642 0.38604019,11.0644928 0.883378875,11.0067277 L1,11 L3,11 L1,11 Z M21,11 L23,11 C23.5522847,11 24,11.4477153 24,12 C24,12.5128358 23.6139598,12.9355072 23.1166211,12.9932723 L23,13 L21,13 C20.4477153,13 20,12.5522847 20,12 C20,11.4871642 20.3860402,11.0644928 20.8833789,11.0067277 L21,11 L23,11 L21,11 Z M3.51289322,3.51289322 C3.87337718,3.15240926 4.44060824,3.12467972 4.83289944,3.42970461 L4.92710678,3.51289322 L6.34710678,4.93289322 C6.73763107,5.32341751 6.73763107,5.95658249 6.34710678,6.34710678 C5.98662282,6.70759074 5.41939176,6.73532028 5.02710056,6.43029539 L4.93289322,6.34710678 L3.51289322,4.92710678 C3.12236893,4.53658249 3.12236893,3.90341751 3.51289322,3.51289322 Z M17.6528932,4.93289322 L19.0728932,3.51289322 C19.4634175,3.12236893 20.0965825,3.12236893 20.4871068,3.51289322 C20.8475907,3.87337718 20.8753203,4.44060824 20.5702954,4.83289944 L20.4871068,4.92710678 L19.0671068,6.34710678 C18.6765825,6.73763107 18.0434175,6.73763107 17.6528932,6.34710678 C17.2924093,5.98662282 17.2646797,5.41939176 17.5697046,5.02710056 L17.6528932,4.93289322 L19.0728932,3.51289322 L17.6528932,4.93289322 Z M12,0 C12.5128358,0 12.9355072,0.38604019 12.9932723,0.883378875 L13,1 L13,3 C13,3.55228475 12.5522847,4 12,4 C11.4871642,4 11.0644928,3.61395981 11.0067277,3.11662113 L11,3 L11,1 C11,0.44771525 11.4477153,0 12,0 Z"
              fill="#F15F22"
              fill-rule="nonzero"
            />
          </svg>
        </div>
        <div class="content">
          <h3>Tips</h3>
        </div>
      </div>
    </div>
    <div class="section-panel-body">
      <ul class="ul-dashed">
        <li
          v-for="(tip, index) in tipList"
          :key="index"
        >
          {{ tip }}
        </li>
      </ul>
      <a
        href="#"
        class="btn btn-block btn-secondary"
        @click.prevent="$emit('close')"
      >Gotcha</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tipList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/__variables.scss';

  .ul-dashed {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      letter-spacing: -0.2px;
      line-height: 2.3rem;
      margin-top: 1rem;
      padding-left: 2.3rem;
      position: relative;

      &:first-of-type {
        margin-top: 0;
      }

      &:before {
        background-color: $primary-color;
        content: "";
        height: 2px;
        left: 0;
        margin-top: 2px;
        position: absolute;
        top: 0.5em;
        width: 10px;
      }
    }
    & + * {
      margin-top: 1.25rem;
    }
  }
</style>
